import { Box, Button } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';
import { runnerTheme } from '../styles/runnerTheme';
export function RunnerRefreshLink({ onRefresh, refreshing }: { onRefresh: () => void; refreshing?: boolean }) {
  const { t } = useTranslation();
  return <Button variant="text" ariaLabel={t('runnerCustomers.refresh')} buttonText={t('runnerCustomers.refresh')} onClick={onRefresh} disabled={refreshing}
    startIcon={<Box component="img" src="/icons/recycle.svg" alt="" sx={{ width: 18, height: 18 }} />}
    textColor={runnerTheme.navy} textDecoration="underline" sx={{ minHeight: 44, minWidth: 0, gap: '6px', px: 1, fontSize: 14, fontWeight: 600, '& .MuiButton-startIcon': { mr: 0 } }} />;
}
